module.exports = __webpack_public_path__ + "assets/img/PJ.8c21f3b0.png";